import axios from 'axios';
import config from '../Config'; // Path to your config file
import authHeader from './auth-header'; // Path to your auth header


const API_URL = config.API_URL; // Base API URL
const API_VERSION = config.API_VERSION; // API version
const addMaterial = (formData) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/material/`,
    formData, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const getMaterialList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/material/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getMaterialDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/material/`, {
    headers: authHeader(),
    params: {
      fields: 'id, name, deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    } // Parameters for pagination and search
  });
};

const getMaterialArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/material-archive', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    }
  });
};
const updateMaterial = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/material/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() } // Authentication header
  );
};
const deleteMaterial = (id) => {
   
  return axios.delete(
      `${API_URL}/api/${API_VERSION}/material/${id}/`,
      { headers: authHeader() }, // Authentication header
    );
};
const unArchiveMaterial = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/material/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const materialService = {
  addMaterial,
  getMaterialList,
  getMaterialArchiveList,
  updateMaterial,
  deleteMaterial,
  unArchiveMaterial,
  getMaterialDropdown
};

export default materialService;
